import {PaymentRequestSettingsService} from '../../services/paymentRequest/PaymentRequestSettingsService';
import {PaymentRequestSettingsStoreProps} from '../../../types/paymentRequestApp.types';

export class PaymentRequestSettingsStore {
  private readonly paymentRequestSettingsService: PaymentRequestSettingsService;

  constructor({paymentRequestSettingsService}: {paymentRequestSettingsService: PaymentRequestSettingsService}) {
    this.paymentRequestSettingsService = paymentRequestSettingsService;
  }

  public toProps(): PaymentRequestSettingsStoreProps {
    return {
      paymentRequestSettings: this.paymentRequestSettingsService.paymentRequestSettings,
    };
  }
}
